import { Domain } from '@server/domain';
import { AgentType } from '@server/ai';

export const getDomainByAgentType = (agentType?: AgentType) => {
  switch (agentType) {
    case AgentType.ProcessOptimization:
      return Domain.BusinessProcess;
    case AgentType.MonitoringV2:
      return Domain.MetadataMonitoring;
    case AgentType.Documentation:
    default:
      return undefined;
  }
};
